export const webRtcInitialState = {
  status: false
};
